import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import makeStyles from '@mui/styles/makeStyles'
import {
  type BasePuiDialogProps,
  type Nil,
  PuiDialog,
} from '@pbt/pbt-ui-components'

import PdfPreview from '~/components/common/pdf/PdfPreview'

import OrderResultsActions from './OrderResultsActions'

const useStyles = makeStyles(
  (theme) => ({
    paper: {
      maxWidth: '100%',
      [theme.breakpoints.down('sm')]: {
        width: 'calc(100% - 32px)',
      },
    },
    dialogContentRoot: {
      padding: theme.spacing(2, 3),
    },
  }),
  { name: 'OrderResultsDialog' },
)

export interface OrderResultsDialogProps extends BasePuiDialogProps {
  canComplete?: boolean
  hasResults?: boolean
  orderId: string | Nil
  pdfUrl: string | Nil
  vendorId: string | Nil
}

const OrderResultsDialog = ({
  open,
  orderId,
  vendorId,
  pdfUrl,
  canComplete = false,
  hasResults = false,
  onClose,
}: OrderResultsDialogProps) => {
  const classes = useStyles()
  const { t } = useTranslation('Common')

  const [pdfPreviewIsLoading, setPdfPreviewIsLoading] = useState(false)

  const title = hasResults
    ? t('Common:LAB_TEST_RESULTS')
    : t('Common:LAB_ORDER')

  return (
    <PuiDialog
      actions={
        <OrderResultsActions
          canComplete={canComplete}
          orderId={orderId}
          pdfUrl={pdfUrl}
          vendorId={vendorId}
        />
      }
      aria-labelledby="order-results-dialog"
      classes={{
        paper: classes.paper,
        dialogContentRoot: classes.dialogContentRoot,
      }}
      disableClose={pdfPreviewIsLoading}
      open={open}
      scroll="paper"
      title={title}
      onClose={onClose}
    >
      <PdfPreview
        fullScreen
        file={{ fileUrl: pdfUrl }}
        setIsLoading={setPdfPreviewIsLoading}
      />
    </PuiDialog>
  )
}

export default OrderResultsDialog
